import type {
  Fields,
  MutationUpdateTemplateArgs,
  Template,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getTemplateKey,
  getTemplatesKey,
} from '../../utils/keys/template.key.js'

export const useUpdateTemplate = (options?: {
  fields?: Fields.TemplateFields
  useMutationOptions?: UseMutationOptions<
    Template,
    Error,
    MutationUpdateTemplateArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Template, Error, MutationUpdateTemplateArgs>(
    variables =>
      client.mutation({
        name: 'updateTemplate',
        args: {
          fields,
          variables,
        },
      }),
    {
      onSettled: (data, error, variables) => {
        queryClient.invalidateQueries(getTemplatesKey())
        queryClient.invalidateQueries(
          getTemplateKey({
            variables: {
              id: variables?.id,
            },
          }),
        )
      },
      ...useMutationOptions,
    },
  )
}
